// extracted by mini-css-extract-plugin
export default {"title_container":"TitleHeader_title_container__We0B5","title_sub_container":"TitleHeader_title_sub_container__9CkTx"};